import { Configurator, DEFAULT_SETTINGS } from "./Configurator";

let config2used = false;

const customConfig = getSettingsFromURI(
  location.search
) as typeof DEFAULT_SETTINGS;
let config = DEFAULT_SETTINGS;

if (customConfig)
  for (const [key, value] of Object.entries(customConfig)) {
    (config as any)[key] = value;
  }

const configurator = new Configurator();
configurator.init(config, config2used);

function getSettingsFromURI(uri: string) {
  let settingString;
  const split = uri.split("&");
  for (let s of split) {
    if (s[0] === "s" || s.includes("s2=")) {
      try {
        settingString = decodeURIComponent(escape(atob(s.split("=")[1])));
      } catch (e) {
        settingString = atob(s.split("=")[1]);
      }
    }
  }

  if (settingString === undefined) {
    return null;
  }

  let jsonString = "{";
  let settings: string[] = settingString.split("\n");

  let config2;

  settings.forEach((s) => {
    const keyAndValue = s.split("=");
    if (keyAndValue.length === 1) {
      return;
    }

    const key = keyAndValue[0].trim();

    const value = keyAndValue[1].trim();

    if (key === "config") {
      config2used = true;
      config2 = JSON.parse(value);
      return JSON.parse(value);
    }

    if (value === "default") {
      return;
    }

    let line = '"' + key.toString() + '": ';

    if (value.includes("[") && value.includes("]")) {
      line += value.toString();
    } else {
      line += '"' + value.toString() + '"';
    }

    if (settings.indexOf(s) < settings.length - 1) {
      line += ",";
    }

    jsonString += line;
  });

  if (config2) {
    return config2;
  }

  jsonString += "}";

  return JSON.parse(jsonString);
}
